import { QIcon_chevron_bold_right, QIcon_thumbs_up_outline } from '@repo/icons/index'
import { useState } from 'react'
import { useEventTracking } from '../../../../../helpers/gtmHelper'
import { APP_SCREEN_NAME } from '../../../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import useReturnFullUrl from '../../../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_ai_analysis } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import urls from '../../../../../modules/urls'
import { COLORS } from '../../../../../modules/vars'

interface ICafJobAnalysisReferralBoxProps {
  page: 'overview' | 'statistic'
  selectedJobId: number
}

const CafJobAnalysisReferralBox = ({ page, selectedJobId }: ICafJobAnalysisReferralBoxProps): JSX.Element => {
  const { t } = useTranslation()
  const [show, setShow] = useState(true)
  const getFullUrl = useReturnFullUrl()
  const router = useAppRouter()
  const isMobile = useIsMobile()
  const { sendClickEvent } = useEventTracking()

  const handleClickReferral = () => {
    sendClickEvent({ button_name: 'ai_analysis_job_segment_referral', object_title: String(selectedJobId) })

    router.push(urls.student.newPortal.mypage.invite, {
      appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
      appSendData: {
        url: getFullUrl(urls.webview.mypage.invite),
      },
    })
  }

  if (!show) return null
  return (
    <div className={styles.container_pc(page)}>
      <div className={styles.box_pc}>
        <div className="flex flex-row items-start justify-start">
          <div className="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-white">
            <QIcon_thumbs_up_outline color={COLORS.PURPLE400} />
          </div>
          <div className="ml-[16px] flex flex-col items-start justify-start">
            <div className={styles.title_pc}>{t(n_ai_analysis.job_segment_referral_title1)}</div>
            <div className={styles.body_pc}>{t(n_ai_analysis.job_segment_referral_title2)}</div>
            <div
              className="mt-[8px] flex w-full cursor-pointer flex-row items-center justify-end text-[14px] font-bold text-purple-500"
              onClick={handleClickReferral}
            >
              {t(n_ai_analysis.job_segment_referral_cta)}
              <QIcon_chevron_bold_right width={16} height={16} color={COLORS.PURPLE500} className="ml-[2px] mb-[1px]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CafJobAnalysisReferralBox

const styles = {
  container: (page) => (page === 'overview' ? `mb-[16px]` : `mx-[20px] pb-[24px]`),
  container_pc: (page) => `mt-[36px] mb-[60px] flex w-full`,
  box: `flex w-full items-start gap-[8px] rounded-[10px] bg-purple-50 p-[16px]`,
  box_pc: `relative flex w-full flex-row items-start justify-between gap-[8px] rounded-[10px] bg-purple-50 p-[16px]`,
  content: `w-full`,
  top: `mb-[4px] flex w-full justify-between gap-[4px]`,
  title: `text-[16px] font-bold`,
  title_pc: `text-[18px] font-bold text-black`,
  body: `mb-[8px] text-[14px] text-gray-700`,
  body_pc: `text-[14px] text-gray-700`,
  bottom: `flex justify-end`,
  button: {
    container: `flex items-center gap-[2px]`,
    text: `text-[14px] font-bold text-black`,
  },
}
